class PickupAvailability extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('available')) return;

    this.errorHtml =
      this.querySelector(
        'template'
      ).content.firstElementChild.cloneNode(true);
    this.onClickRefreshList = this.onClickRefreshList.bind(this);
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const rootUrl = !this.dataset.rootUrl.endsWith('/')
      ? `${this.dataset.rootUrl}/`
      : this.dataset.rootUrl;

    const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
        this.sortLocations();
      })
      .catch(e => {
        const button = this.querySelector('button');

        if (button)
          button.removeEventListener(
            'click',
            this.onClickRefreshList
          );

        this.renderError();
      });
  }

  onClickRefreshList(event) {
    this.fetchAvailability(this.dataset.variantId);
  }

  renderError() {
    this.innerHTML = '';
    this.appendChild(this.errorHtml);
    this.querySelector('button').addEventListener(
      'click',
      this.onClickRefreshList
    );
  }

  renderPreview(sectionInnerHTML) {
    if (
      !sectionInnerHTML.querySelector('pickup-availability-preview')
    ) {
      this.innerHTML = '';
      this.removeAttribute('available');

      return;
    }

    this.innerHTML = sectionInnerHTML.querySelector(
      'pickup-availability-preview'
    ).outerHTML;
    this.setAttribute('available', '');
  }

  sortLocations() {
    const storesList = this.querySelector('.pickup-availability-stores');
    if (!storesList) return;

    const stores = Array.from(storesList.querySelectorAll('.pickup-availability-store'));
    const availableStore = stores.find(store => {
      const preview = store.querySelector('.pickup-availability-store__preview');
      return preview && preview.textContent.toLowerCase().includes('pickup available');
    });

    if (availableStore) {
      // Move available store to the top
      storesList.prepend(availableStore);
      
      // Update the preview section with the available store's information
      const storeName = availableStore.querySelector('.pickup-availability-store__title').textContent;
      const pickupTime = availableStore.querySelector('.pickup-availability-store__preview').textContent.trim();
      
      const previewTitle = this.querySelector('.pickup-availability__info-title');
      const previewMeta = this.querySelector('.pickup-availability__info-meta');
      
      if (previewTitle) {
        previewTitle.innerHTML = `
          <div class="pickup-availability-store__preview_text">
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.3337 1L5.00033 8.33333L1.66699 5" stroke="#6BBD4F" stroke-linecap="square"></path>
            </svg> 
            <div>Pickup <b>available</b> at <b>${storeName}</b>
            </div>
          </div>
        `;
      }
      
      if (previewMeta) {
        previewMeta.textContent = pickupTime;
      }
    }
  }
}

customElements.define('pickup-availability', PickupAvailability);